import 'owl.carousel';

jQuery(function ($) {

  // MOBILE MENU TOGGLE
  $('.mobile-menu-icon').on('click', function () {
    $("header").toggleClass('active');
    $(".header-main-navigation-wrapper").toggleClass('active');
    $('.line').toggleClass('active');
  });


  // GALLERY LIST TEMPLATE LOGIC
  const $selectorItems = $('.selector-item');
  const $galleryGroups = $('.gallery-group');

  let activeId = $selectorItems.first().data('target');

  function showGallery(targetId) {
    $galleryGroups.hide();
    $galleryGroups.filter(`[data-id="${targetId}"]`).show();
  }

  // Initialize with first gallery
  showGallery(activeId);

  $selectorItems.each(function () {
    const $item = $(this);
    const targetId = $item.data('target');

    $item.on('mouseenter', function () {
      showGallery(targetId);
    });

    $item.on('mouseleave', function () {
      showGallery(activeId);
    });

    $item.on('click', function () {
      activeId = targetId;
      showGallery(activeId);

      // Optional: active class toggle
      $selectorItems.removeClass('active');
      $item.addClass('active');
    });
  });


  jQuery(function ($) {
    const $items = $('.content-selector .selector-item');
    const $groups = $('.list-content .group');

    // Default active = first item
    let activeId = $items.first().data('target');

    function show(id) {
      if (!id) return;
      $groups.hide();
      $groups.filter('[data-id="' + id + '"]').show();
    }

    // Init
    show(activeId);
    $items.removeClass('active').first().addClass('active');

    // Hover / focus = preview
    $items.on('mouseenter focus', function () {
      const id = $(this).data('target');
      show(id);
    });

    // Leave / blur = revert to active
    $items.on('mouseleave blur', function () {
      show(activeId);
    });

    // Click (or Enter/Space) = set active
    function setActive($el) {
      activeId = $el.data('target');
      $items.removeClass('active');
      $el.addClass('active');
      show(activeId);
    }

    $items.on('click', function (e) {
      e.preventDefault();
      setActive($(this));
    });

    // Keyboard support: Enter/Space
    $items.on('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        setActive($(this));
      }
    });
  });


  // Accordion toggle (jQuery version) — slide panel, then fade content, toggle icon
  var SLIDE_MS = 220;
  var FADE_IN_MS = 160;
  var FADE_OUT_MS = 100;

  /**
   * Set expanded/collapsed state for a single accordion trigger.
   * @param {jQuery} $btn      The .accordion-trigger button
   * @param {boolean} expand   true = open, false = close
   * @param {{animate?: boolean}} [opts]
   */
  function setAccordionExpanded($btn, expand, opts) {
    var options = opts || {};
    var animate = options.animate !== false; // default true

    var controls = $btn.attr('aria-controls');
    var $panel = $('#' + controls);
    var $content = $panel.find('.accordion-content');

    // Aria + icon
    $btn.attr('aria-expanded', expand ? 'true' : 'false');
    $btn.find('.accordion-icon, .accordian-icon').toggleClass('open', expand);

    if (!animate) {
      // No animation: just snap to state
      if (expand) {
        $panel.stop(true, true).show().removeAttr('hidden');
        $content.css('opacity', 1);
      } else {
        $panel.stop(true, true).hide().attr('hidden', '');
        $content.css('opacity', 0);
      }
      return;
    }

    if (expand) {
      // EXPAND: prepare panel + content, then animate
      if ($panel.is('[hidden]')) $panel.removeAttr('hidden'); // must be visible to animate
      $content.stop(true, true).css('opacity', 0);            // text hidden at start

      // Ensure panel starts hidden for slideDown
      if ($panel.css('display') !== 'none') $panel.hide();

      $panel.stop(true, true).slideDown(SLIDE_MS, function () {
        // After slide completes, fade in text
        $content.animate({ opacity: 1 }, FADE_IN_MS);
      });

    } else {
      // COLLAPSE: fade text, then slide up, then set hidden
      $content.stop(true, true).animate({ opacity: 0 }, FADE_OUT_MS, function () {
        $panel.stop(true, true).slideUp(SLIDE_MS, function () {
          $panel.attr('hidden', ''); // restore hidden for a11y/semantics
        });
      });
    }
  }

  // Click handler (delegated) for individual items
  $(document).on('click', '.accordion-trigger', function () {
    var $btn = $(this);
    var expanded = $btn.attr('aria-expanded') === 'true';
    setAccordionExpanded($btn, !expanded, { animate: true });
  });

  // Expand / Collapse all panels within a single accordion block
  $(document).on('click', '.accordion-controls .expand-all', function (e) {
    e.preventDefault();

    var $toggleBtn = $(this);
    var $block = $toggleBtn.closest('.accordion-list-block');

    // Only triggers in items that are not hidden by the filter
    var $triggers = $block.find('.accordion-item:not([hidden]) .accordion-trigger');

    if (!$triggers.length) return;

    // Are all visible items currently open?
    var openCount = $triggers.filter('[aria-expanded="true"]').length;
    var allOpen = (openCount === $triggers.length);

    // If all are open, we want to close all; otherwise open all
    var shouldOpen = !allOpen;

    $triggers.each(function () {
      setAccordionExpanded($(this), shouldOpen, { animate: true });
    });

    // Toggle the arrow icon on the Expand All button
    $toggleBtn
      .attr('aria-pressed', shouldOpen ? 'true' : 'false')
      .find('.accordion-icon, .accordian-icon')
      .toggleClass('open', shouldOpen);
  });

  // INIT: sync panels/icons to current aria-expanded on load
  $('.accordion-trigger').each(function () {
    var $b = $(this);
    var isExpanded = $b.attr('aria-expanded') === 'true';
    setAccordionExpanded($b, isExpanded, { animate: false });
  });


  // small debounce helper
  function debounce(fn, ms) {
    let t;
    return function () {
      const ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  function initAccordionFilter(rootId) {
    const $input = $(`input[data-accordion-search="${rootId}"]`);
    const $lists = $(`ul[data-accordion-group="${rootId}"]`);
    const $groupRoot = $(`[data-accordion-root="${rootId}"]`);
    if (!$input.length || !$lists.length) return;

    // All items across all accordions in this group
    const $items = $lists.find('.accordion-item');
    const $noResults = $(`#${rootId}-no-results`);

    const run = function () {
      const q = $.trim($input.val() || '').toLowerCase();
      let shown = 0;

      $items.each(function () {
        const $li = $(this);
        const hay = String($li.data('search') || '').toLowerCase();
        const match = !q || hay.indexOf(q) !== -1;

        if (match) {
          // show item
          $li.removeAttr('hidden');
          shown++;
        } else {
          // hide item
          $li.attr('hidden', 'hidden');

          // if hiding an expanded item, collapse it for a11y/state consistency
          const $btn = $li.find('.accordion-trigger').first();
          if ($btn.length && $btn.attr('aria-expanded') === 'true') {
            setAccordionExpanded($btn, false, { animate: false });
          }
        }
      });

      // Hide entire accordion sections that have no visible items
      if ($groupRoot.length) {
        $groupRoot.find('.accordion-list-block').each(function () {
          const $section = $(this);
          const visibleCount = $section.find('.accordion-item:not([hidden])').length;

          if (visibleCount === 0) {
            $section.attr('hidden', 'hidden');
          } else {
            $section.removeAttr('hidden');
          }
        });
      }

      if ($noResults.length) {
        $noResults.attr('hidden', shown !== 0);
      }
    };

    // react to typing and native "search" clear (Safari/Chrome)
    $input.on('input search', debounce(run, 120));
  }


  // auto-init for all block groups on the page
  (function () {
    const rootIds = new Set();

    $('input[data-accordion-search]').each(function () {
      const id = String($(this).data('accordion-search') || '');
      if (id) rootIds.add(id);
    });

    rootIds.forEach(function (id) {
      initAccordionFilter(id);
    });
  })();


  // DESCRIPTION TOGGLE for profile cards
  $(document).on('click', '.description-wrapper.description-toggle', function () {
    const $wrapper = $(this);
    const $description = $wrapper.find('.description');
    const isExpanded = $description.hasClass('expanded');

    // Toggle expanded state
    $description.toggleClass('expanded');
    $wrapper.toggleClass('expanded');

    // Update aria-expanded for accessibility
    $wrapper.attr('aria-expanded', !isExpanded);
  });

  // Keyboard support for description toggle
  $(document).on('keydown', '.description-wrapper.description-toggle', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      $(this).trigger('click');
    }
  });


});

(function () {
  const header = document.querySelector('header');

  function toggleHeaderBg() {
    if (window.scrollY > 10) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }

  toggleHeaderBg();
  window.addEventListener('scroll', toggleHeaderBg);
})();
